import { useCallback } from 'react';
import { useFeatureFlagsContext } from '../ui/FeatureFlagsContext/FeatureFlagsContext';

export enum Features {
  eventPostbacksReview = 'eventPostbacksReview',
  lifetimeSelectTwoYearsExtension = 'lifetimeSelectTwoYearsExtension',
  lifetimeSelectThreeYearsExtension = 'lifetimeSelectThreeYearsExtension',
  navigationV1Switcher = 'navigationV1Switcher',
}

enum AccessEntity {
  user = 'user',
  company = 'company',
  organization = 'organization',
}
type AccessRecord =
  | {
      type: AccessEntity.company;
      postfix: string;
    }
  | { type: AccessEntity.user; email: string }
  | { type: AccessEntity.organization; organizationId: string };

const FEATURE_GROUPS: Record<Features, AccessRecord[]> = {
  [Features.eventPostbacksReview]: [],
  [Features.lifetimeSelectTwoYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: '4a6b0c93-ecda-46ea-bd58-92553abb73ae',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7c2d76c6-b64a-4cc8-87e0-d5c303e77765',
    },
  ],
  [Features.lifetimeSelectThreeYearsExtension]: [
    {
      type: AccessEntity.organization,
      organizationId: 'dd59e7c3-7668-47d9-999c-7909cfabe234',
    },
  ],
  [Features.navigationV1Switcher]: [
    {
      type: AccessEntity.organization,
      organizationId: '400a4a4e-34a3-4661-a547-0b2a6d76809f',
    },
    {
      type: AccessEntity.organization,
      organizationId: '6466a2b3-e65b-4da0-83e6-4d5c5beaf65b',
    },
    {
      type: AccessEntity.organization,
      organizationId: '75e17416-a94e-4a9a-bcfc-220db384433f',
    },
    {
      type: AccessEntity.organization,
      organizationId: '3f092d51-3a29-460e-9089-08e2c5460356',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'a8c70baf-24d2-448a-8827-c9abdac18b7a',
    },
    {
      type: AccessEntity.organization,
      organizationId: '8acf1e60-f6be-4070-995b-9d6fa0f58489',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'cc642671-d665-4a95-84f8-4da7277ccb96',
    },
    {
      type: AccessEntity.organization,
      organizationId: '932d04c9-f8ca-4b86-acd5-2e6851936c12',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'c9548ff9-1d5d-410f-afbe-f1fc5cb56b35',
    },
    {
      type: AccessEntity.organization,
      organizationId: '76d26568-277a-4950-b075-125d17449f41',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'de17f195-7ce4-4e80-91ed-bee3b5150bb5',
    },
    {
      type: AccessEntity.organization,
      organizationId: '02738868-66e2-4108-985d-c6d1e4b2c69b',
    },
    {
      type: AccessEntity.organization,
      organizationId: '738cbd8b-56b1-472b-9666-d6f9aad9650a',
    },
    {
      type: AccessEntity.organization,
      organizationId: '569ca689-0908-4446-abc6-7d7654ba21ae',
    },
    {
      type: AccessEntity.organization,
      organizationId: '6416377e-fbf5-43f7-805b-45067b765522',
    },
    {
      type: AccessEntity.organization,
      organizationId: '828a5560-211e-4382-98a9-f0a165d56234',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'abdd4c37-b27d-4594-99dc-2d7e5e857a8d',
    },
    {
      type: AccessEntity.organization,
      organizationId: '00adc76e-96fc-4f40-a6a3-a0eabb14c0c2',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'ed2aff88-565d-42e0-9d64-25bf1231ee87',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7c2d76c6-b64a-4cc8-87e0-d5c303e77765',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'dd59e7c3-7668-47d9-999c-7909cfabe234',
    },
    {
      type: AccessEntity.organization,
      organizationId: '267423ef-d636-45eb-8cea-a910d0953dc1',
    },
    {
      type: AccessEntity.organization,
      organizationId: '454d5138-86c9-415d-b9dd-d69e0982beea',
    },
    {
      type: AccessEntity.organization,
      organizationId: '19d0c4f0-1e77-440e-b29d-e30e02c948db',
    },
    {
      type: AccessEntity.organization,
      organizationId: '73ec9fe7-edc4-4446-ae05-0caf479a9005',
    },
    {
      type: AccessEntity.organization,
      organizationId: '72027eae-a5a6-4810-94f5-4fc795cc3334',
    },
    {
      type: AccessEntity.organization,
      organizationId: '2f8b073c-559c-4069-bf1f-7fd4ef140f1c',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'db8c2d06-7f51-492a-8d7a-d4fcd8331710',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'bcc49cd1-e9b7-48f8-bf61-d85611db629c',
    },
    {
      type: AccessEntity.organization,
      organizationId: '5acac618-671d-41cb-91fb-d086123ef0e6',
    },
    {
      type: AccessEntity.organization,
      organizationId: '8a9b79a8-d67e-4fd0-87b6-33bb6dd20095',
    },
    {
      type: AccessEntity.organization,
      organizationId: '35099836-1ba8-4bac-aaff-2fd56a28ad93',
    },
    {
      type: AccessEntity.organization,
      organizationId: '37b03e8b-f513-42e0-8fb9-e717d9cb47e6',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'bd51ad58-8b38-4848-a719-eaea8252f6ab',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'e8eab7e1-5be2-47d9-a0a0-ffd494ba4a5c',
    },
    {
      type: AccessEntity.organization,
      organizationId: '25ae58fd-5287-477d-83fb-585fb55e6ca1',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'f731a1d0-7e4e-463f-8d70-24dd117c5da6',
    },
    {
      type: AccessEntity.organization,
      organizationId: '14592ae3-3912-4f15-8f38-356e4a8610fb',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'c0ccdf8d-7d41-4b54-b756-b91cc978a7bf',
    },
    {
      type: AccessEntity.organization,
      organizationId: '47356258-4da9-4034-8253-c6bd24569e9e',
    },
    {
      type: AccessEntity.organization,
      organizationId: '4b90f654-a0e1-4a1f-8460-2a6d59f4371b',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'fc7cf45b-3778-4361-b197-91e1ccd15862',
    },
    {
      type: AccessEntity.organization,
      organizationId: '61db9465-03a8-4cb4-8eae-0a30efe50ab7',
    },
    {
      type: AccessEntity.organization,
      organizationId: '2cf58c86-5654-4f76-9f0c-493bd184bef0',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'c6e46a04-940d-4aab-97cc-8f3097cb4e9f',
    },
    {
      type: AccessEntity.organization,
      organizationId: '4a6b0c93-ecda-46ea-bd58-92553abb73ae',
    },
    {
      type: AccessEntity.organization,
      organizationId: '242cc389-cf5c-4bd7-ac3c-bdd879f5f3c5',
    },
    {
      type: AccessEntity.organization,
      organizationId: '7edc42f4-ba62-4290-a65f-1989774ac106',
    },
    {
      type: AccessEntity.organization,
      organizationId: '57cef42c-f1e3-4c00-b523-346df6dad2ea',
    },
    {
      type: AccessEntity.organization,
      organizationId: '54118ea6-a267-4cc1-8146-17e8d2f084ca',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'c51d1d38-b76b-40e9-a932-0859e5ffebd7',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'f37c0d6f-b70e-4129-aea6-7e52fc58d236',
    },
    {
      type: AccessEntity.organization,
      organizationId: '4d37cffe-f2cd-43a3-b070-5f41ac16c718',
    },
    {
      type: AccessEntity.organization,
      organizationId: '671a6296-e3e9-4960-8c70-5c11a7a4b3b4',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'b1aed2a9-18f5-476a-bc25-d3e78364a376',
    },
    {
      type: AccessEntity.organization,
      organizationId: '5794b7ba-01ba-4721-83f8-96cb83699b49',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'cbeae8c5-34a2-49c8-bd64-6294c14cf446',
    },
    {
      type: AccessEntity.organization,
      organizationId: '1609805c-58b9-4a14-a13b-97427378ffa2',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'e6119c61-4d87-4714-933c-dbfcc640cd83',
    },
    {
      type: AccessEntity.organization,
      organizationId: '3ab53f8f-1786-4642-b289-7ab598925571',
    },
    {
      type: AccessEntity.organization,
      organizationId: '3876acdc-483d-411c-9c50-fd8ca30307df',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'dd5bd051-47ba-467d-9805-2d3dbcb589e9',
    },
    {
      type: AccessEntity.organization,
      organizationId: '3046960e-e919-45f9-990d-9405749fa86e',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'f5185652-604c-43ee-82bd-241d31f0ffeb',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'fabaa2a4-f280-46a2-a65d-2ec6e13bc4ad',
    },
    {
      type: AccessEntity.organization,
      organizationId: 'b2a4f92c-e1c3-4815-9348-81ecf20095ff',
    },
  ],
};

export const useFeatureFlags = () => {
  const { email, organizationId } = useFeatureFlagsContext();
  const isFeatureAvailable = useCallback(
    (feature: Features) => {
      const groups = FEATURE_GROUPS[feature];

      return (
        !!email &&
        groups.some((group) => {
          switch (group.type) {
            case AccessEntity.company:
              return email.endsWith(group.postfix);
            case AccessEntity.user:
              return email === group.email;
            case AccessEntity.organization:
              return organizationId === group.organizationId;
          }

          return false;
        })
      );
    },
    [email, organizationId],
  );

  return {
    isFeatureAvailable,
  };
};
